import { createSelector } from '@ngrx/store';
import { IMyBuildingState } from './my-building.reducer';

export const selectMyBuildingState = state => state?.myBuildingState;

export const getCurrentBuilding = createSelector(
	selectMyBuildingState,
	(state: IMyBuildingState) => state?.currentBuilding
);
export const getCurrentBuildingId = createSelector(
	selectMyBuildingState,
	(state: IMyBuildingState) => state?.currentBuilding?.locationId
);
